import { BCMSCurrency, DisabledPrompt, useStateManager } from "@bcm-dev/bcms-vite";
import CustomSelect, { CustomSelectItem } from "components/custom-ui/CustomSelect";
import DateSelect from 'components/custom-ui/DateSelect';
import { TableBody, TableView } from 'components/shared';
import { UIAmountInput, UITextInput } from 'components/ui';
import React from 'react';
import { SVGAsset } from "res";

/**
 * @function TASPositivePaySubmittedChecksDesktopView
 * @return {React.Component}
 * @exported true
 * @description The TAS Positive Pay Add Check desktop content view.
 */
export default function TASPositivePaySubmittedChecksDesktopView(props) {
      const { data } = useStateManager();
      const checkForms = data.checkForms;
      const canDeleteCheckForms = checkForms.length > 1;

      const rows = checkForms.reduce((acc, item) => {
        const amount = item.amount ? BCMSCurrency.init(item.amount).format() : "";

        acc.push(
          <tr key={ item.id } className="table-item-container">
            <td className="table-item-view">
              <span>{ `${ item.account.name } ${ item.account.number }` }</span>
            </td>
            <td className="table-item-view">
              <span>{ `${ item.issuedDate.format("m/d/Y") }`}</span>
            </td>
            <td className="table-item-view">
              <span>{ `${ item.checkNumber }` }</span>
            </td>
            <td className="table-item-view">
              <span>{ `${ amount }` }</span>
            </td>
            <td className="table-item-view">
              <span>{ `${ item.payee }` }</span>
            </td>
            <td className="table-item-view">
              <span>{ `${ item.referenceNumber }` }</span>
            </td>
            <td className="table-item-view type">
              <span>{ `${ item.type }` }</span>
            </td>
            <td className="table-item-view status">
              <span>{ `${ item.status }` }</span>
            </td>
            <td className="table-item-view">
              <DisabledPrompt>
                <SVGAsset id="EditIcon" className="clickable" />
              </DisabledPrompt>
            </td>
            <td className="table-item-view">
              <DisabledPrompt>
                 <SVGAsset id="TrashIcon" className="clickable" />
              </DisabledPrompt>
            </td>
          </tr>
        );
        return acc;
      }, []);

    return (
        <div className="flex-container table-view-container show-on-desktop">
        <TableView className="tas-positive-pay-submitted-checks-table">
            <thead className="table-column-container">
            <tr>
                <th className="text-left table-column-view">Account</th>
                <th className="text-left table-column-view">Issued Date</th>
                <th className="text-left table-column-view">
                  <span>Check</span><br/><span>Number</span>
                </th>
                <th className="text-left table-column-view">Amount</th>
                <th className="text-left table-column-view">Payee</th>
                <th className="text-left table-column-view">
                  <span>Reference</span><br/><span>Number</span>
                </th>
                <th className="text-left table-column-view">Type</th>
                <th className="text-left table-column-view">Status</th>
                <th className="text-left table-column-view"></th>
                <th className="text-left table-column-view"></th>
                { canDeleteCheckForms && <th className="text-left table-column-view"></th> }
            </tr>
            </thead>
            <TableBody>{ rows } </TableBody>
        </TableView>
        </div>
    );
}